var map = {
	"./about-banner.png": "KI8p",
	"./beian.png": "XNTI",
	"./bottom.png": "MGEE",
	"./contact-banner.png": "Va8t",
	"./creative-banner.png": "vftr",
	"./douy.png": "vchz",
	"./industry-case-banner.jpg": "e3R4",
	"./logo.png": "iQH9",
	"./news-album.png": "ND1T",
	"./news-banner.png": "tzan",
	"./news-logo.png": "EhHi",
	"./news-qrcode.png": "F47w",
	"./qrcode.png": "/4D4",
	"./s-icon1.png": "M4BB",
	"./s-icon2.png": "9mPj",
	"./s-icon3.png": "N3Rb",
	"./solution-banner.jpg": "qDYq",
	"./solution-case-en.png": "Zmfd",
	"./solution-case-m-en.png": "+CYF",
	"./solution-case-m.png": "1SX0",
	"./solution-case.png": "fjdJ",
	"./solution-check-m-en.png": "uH8r",
	"./solution-check-m.png": "g6fT",
	"./solution-check-pc-en.png": "SNe3",
	"./solution-check-pc.png": "cs5Y",
	"./solution1.png": "M3XI",
	"./solution2.png": "c3+U",
	"./tout.png": "hjge",
	"./weis-qr.png": "dRmz",
	"./weis.png": "DqAt",
	"./weix-qr.jpg": "4vUC",
	"./weix.png": "sGLz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 1